import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import stockAdjustmentService from "../../../services/stockAdjustmentService";

const initialState = {
  adjustments:  [],
  adjustment:   null,
  isLoading:    false,
  error:        null,
};

export const createAdjustment    = createAsyncThunk("stockAdj/create",    async (data, t)        => { try { return await stockAdjustmentService.createAdjustment(data); }    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const getAdjustments      = createAsyncThunk("stockAdj/getAll",    async (params, t)      => { try { return await stockAdjustmentService.getAdjustments(params); }     catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const getSingleAdjustment = createAsyncThunk("stockAdj/getSingle", async (id, t)          => { try { return await stockAdjustmentService.getSingleAdjustment(id); }    catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const updateAdjustment    = createAsyncThunk("stockAdj/update",    async ({ id, data }, t) => { try { return await stockAdjustmentService.updateAdjustment(id, data); } catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const deleteAdjustment    = createAsyncThunk("stockAdj/delete",    async (id, t)          => { try { return await stockAdjustmentService.deleteAdjustment(id); }        catch (e) { return t.rejectWithValue(e.response?.data?.message || e.message); } });
export const convertStock = createAsyncThunk(
  "stockAdj/convert",
  async (data, t) => {
    try {
      return await stockAdjustmentService.convertStock(data);
    } catch (e) {
      return t.rejectWithValue(e.response?.data?.message || e.message);
    }
  }
);

const stockAdjustmentSlice = createSlice({
  name: "stockAdjustment",
  initialState,
  reducers: {
    resetAdjustmentState: (state) => {
      state.isLoading = false; state.error = null; state.adjustment = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createAdjustment.pending,   (state) => { state.isLoading = true; })
      .addCase(createAdjustment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adjustments.unshift(action.payload);
        toast.success("Stock adjustment recorded");
      })
      .addCase(createAdjustment.rejected,  (state, action) => { state.isLoading = false; toast.error(action.payload); })
      .addCase(getAdjustments.pending,     (state) => { state.isLoading = true; })
      .addCase(getAdjustments.fulfilled,   (state, action) => {
        state.isLoading = false;
        state.adjustments = Array.isArray(action.payload) ? action.payload : action.payload?.data || [];
      })
      .addCase(getAdjustments.rejected,    (state, action) => { state.isLoading = false; })
      .addCase(getSingleAdjustment.fulfilled, (state, action) => { state.isLoading = false; state.adjustment = action.payload; })
      .addCase(updateAdjustment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adjustments = state.adjustments.map(a => a._id === action.payload._id ? action.payload : a);
        toast.success("Adjustment updated");
      })
      .addCase(deleteAdjustment.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adjustments = state.adjustments.filter(a => a._id !== action.payload._id);
        toast.success("Adjustment deleted and stock restored");
      })
      .addCase(convertStock.pending,   (state) => { state.isLoading = true; })
      .addCase(convertStock.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adjustments.unshift(action.payload.adjustment);
        toast.success("Stock converted successfully");
      })
      .addCase(convertStock.rejected,  (state, action) => {
        state.isLoading = false;
        toast.error(action.payload);
      });
  },
});

export const { resetAdjustmentState } = stockAdjustmentSlice.actions;
export default stockAdjustmentSlice.reducer;